import { render } from "./DeelnemersCommun.vue?vue&type=template&id=a4b457da&scoped=true"
import script from "./DeelnemersCommun.vue?vue&type=script&lang=js"
export * from "./DeelnemersCommun.vue?vue&type=script&lang=js"

import "./DeelnemersCommun.vue?vue&type=style&index=0&id=a4b457da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b457da"]])

export default __exports__